/**
 * The items over the Warehouse page's list (SCRUM-647). Owner, 19.10.2026: «вообще убирай этот рентал desk из меню
 * оставь варехауз как было и всё это на странице варехауза размести» — a row of items in the shows-tabs look: Warehouse
 * (the list, today's page, the default), To answer (offers waiting on me) and My shows (crew links and work progress).
 * The address follows the item. Pure, so it is tested without a page.
 */
export const WAREHOUSE_TABS = ["warehouse", "answer", "shows"] as const;
export type WarehouseTab = (typeof WAREHOUSE_TABS)[number];

/** The item an address names; anything else is the Warehouse itself. */
export function parseWarehouseTab(value: string | null): WarehouseTab {
  return value === "answer" || value === "shows" ? value : "warehouse";
}

/** The address an item shows. `back` is the way back to an offer (SCRUM-636): it rides along on the Warehouse item only. */
export function warehouseTabAddress(tab: WarehouseTab, back: string | null): string {
  if (tab === "answer") return "/warehouse?tab=answer";
  if (tab === "shows") return "/warehouse?tab=shows";
  return back ? `/warehouse?back=${encodeURIComponent(back)}` : "/warehouse";
}
